import type { DogSize } from "shared/types";

export const DOG_SIZE_UNSPECIFIED = "";

export type DogSizeValue = DogSize | typeof DOG_SIZE_UNSPECIFIED;

const dogSizeLabels: Record<DogSize, string> = {
  small: "Small only",
  large_and_small: "Large & small"
};

export const dogSizeOptions = [
  { value: DOG_SIZE_UNSPECIFIED, label: "Not specified" },
  { value: "small", label: dogSizeLabels.small },
  { value: "large_and_small", label: dogSizeLabels.large_and_small }
];

export const getDogsAllowedLabel = (
  dogsAllowed?: boolean | null,
  dogSize?: DogSize | null
) => {
  if (dogsAllowed == null) return "-";
  if (!dogsAllowed) return "No";
  if (dogSize) return dogSizeLabels[dogSize];
  return "Yes";
};

export const toDogSizeValue = (dogSize?: DogSize | null): DogSizeValue =>
  dogSize ?? DOG_SIZE_UNSPECIFIED;

export const toDogSizePayload = (value?: DogSizeValue): DogSize | null =>
  value ? value : null;
